<template>
  <el-card header="视频信息" class="box-card">
    <el-form
      :model="formData"
      :rules="rules"
      ref="dataForm"
      label-width="100px"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" />
      </el-form-item>
      <el-form-item label="缩略图" prop="imgUrl">
        <el-upload
          class="avatar-uploader"
          action="/dealer/video/upload"
          :show-file-list="false"
          :headers="uploadHeaders"
          :on-success="handleImgUpload"
        >
          <img v-if="formData.imgUrl" :src="formData.imgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-input v-model="formData.imgUrl" />
      </el-form-item>
      <el-form-item label="视频" prop="videoUrl">
        <el-input v-model="formData.videoUrl" />
        <el-upload
          action="/dealer/video/upload"
          :show-file-list="true"
          :headers="uploadHeaders"
          :on-success="handleVideoUpload"
        >
          <el-button size="small">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        id: null,
        name: "",
        imgUrl: "",
        videoUrl: "",
      },
      typeList: [],
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        imgUrl: [{ required: true, message: "请上传缩略图", trigger: "blur" }],
        videoUrl: [{ required: true, message: "请上传视频", trigger: "blur" }],
      },
    };
  },
  created: function () {
    this.formData.id = this.$route.query.id;
    if (this.formData.id) {
      this.fetchData();
    }
  },
  computed:{
    uploadHeaders(){
      return {"token-dealer": localStorage.getItem("token-dealer")}
    }
  },
  methods: {
    fetchData() {
      var that = this;
      that.api.dealer.video.get({ id: that.formData.id }).then((response) => {
        if (!response.data.errorCode) {
          Object.assign(that.formData, response.data.data);
        }
      });
    },
    handleImgUpload(response, file, fileList) {
      this.formData.imgUrl = response.data;
    },
    handleVideoUpload(response, file, fileList) {
      this.formData.videoUrl = response.data;
    },
    submitForm() {
      var that = this;
      that.$refs["dataForm"].validate((valid) => {
        if (valid) {
          that.api.dealer.video
            .save(Object.assign({}, that.formData))
            .then(function (response) {
              if (!response.data.errorCode) {
                that.$router.go(-1);
              }
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs["dataForm"].resetFields();
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// Edit.vue?14d27218